module.exports = __webpack_public_path__ + "static/img/StephanieGilmore.1f90010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/StephanieGilmore.jpg
// module id = DfQY
// module chunks = 0